<template>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M3 1C3 1 1 2.5 1 6C1 9.5 3 11 3 11"
  />
</template>
